import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const TyC = () => {
  return (
    <div className="py-5 bg-light" style={{minHeight: "100vh"}}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <h1 className="mb-4 text-center">Términos y condiciones</h1>

            <p><strong>Próximamente</strong></p>


          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TyC;
